<template>
  <div>
    <input v-if="show_input" type="text" class="form-control" v-model.lazy="alias" :placeholder="circuitData.alias">
    <button v-else type="button" class="btn btn-success btn-sm" @click="show_input = true">編輯名稱</button>
  </div>
</template>

<script>
export default {
  props: ['circuitData', 'showInput'],
  data() {
    return {
      show_input: false,
      alias: '',
    };
  },
  computed: {
    bx_mac() {
      return this.$store.getters.selectedMeter.bx_mac;
    }
  },
  watch: {
    showInput() {
      this.show_input = false;
    },
    alias(alias) {
      const update_circuit = {
        bx_mac: this.bx_mac,
        bx_circuit_id: this.$props.circuitData.id,
        alias: alias
      }
      axios.patch(base_url + "/api/bx/", update_circuit)
        .then((response) => {
          this.$store.dispatch('setUserRegions');
        }).catch(function (error) {
          console.error(error);
        });
      this.alias = '';
    }
  }
};
</script>
